export default __webpack_public_path__ + "static/media/automatskavrata2.797c5324.png";